import { Box, Typography, Table, TableHead, TableBody, TableRow, TableCell, Paper, Divider } from "@mui/material";
import React from "react";
import DoughnutPieChart from "../../../../components/charts/Doughnut_Pie";
import Weaknesses from "../../../../components/charts/Weakness";
import { useTranslation } from "react-i18next";

export default function TefExport({ tefData }) {
    // Aggregate TEF avg data for the DoughnutPieChart
    const {t} = useTranslation();
    const aggregatedData = tefData
    .map((tef) => ({
        Title: tef["threat"], // Use the threat name as the label
        Count: tef["avg"], // Use the TEF avg as the value
    }))
    .sort((a, b) => b.Count - a.Count); // Sort by Count (TEF avg) in descending order

    return (
        <Box sx={{ bgcolor: "#f9f9f9", padding: "20px" }}>
            {/* Main Container */}
            <Box
                 id={`tlm-threat-`}
                sx={{
                    width: "210mm", // A4 width
                    margin: "auto", // Center the box horizontally
                    marginBottom: "20px",
                    boxShadow: 3,
                    borderRadius: 2,
                    bgcolor: "#f9f9f9",
                    padding: "20px",
                    boxSizing: "border-box",
                    overflow: "hidden",
                }}
            >
          
           {/* Threat Title */}
                <Typography
                    sx={{
                    textAlign: "start",
                    marginBottom: "10px",
                    fontWeight: "bold",
                    }}
                    variant='h5'
                >
                    Section 2 : Threat Landscape Analysis
                </Typography>

                <Typography sx={{textAlign: "start",fontSize: "0.875rem", marginBottom: "10px" }}>
                    {`This section presents a comprehensive overview of the Threat Event Frequency (TEF) across various cybersecurity threat categories. TEF, which represents the estimated number of threat events that could occur within a year, has been evaluated using insights from multiple cybersecurity reports referenced in the document. These reports, published by reputable organizations in the field, offer valuable statistics and industry-specific threat intelligence.
 
The analysis covers five key threat scenarios: Ransomware (malware that encrypts data for ransom), Denial of Service (DoS) attacks (disrupting system availability), Social Engineering (exploiting human behavior for unauthorized access), Supply Chain attacks (targeting the organization through its vendors or suppliers), and Data Breaches (unauthorized access or exposure of sensitive information). For each scenario, we've estimated a TEF range based on the company's profile, considering factors such as its size, industry sector, and potential attractiveness to threat actors. The graph visually represents the average TEF for each threat type, while the table provides more detailed information including minimum and maximum TEF values and brief descriptions.`
                    .replace(/\. /g, '.\n\n')}
                </Typography>

                {/* Chart Section */}
                <Box
                    sx={{
                        boxShadow: 3,
                        borderRadius: 2,
                        padding: "20px",
                        bgcolor: "background.paper",
        
                        minHeight: "400px",
                        textAlign: "center",
                        marginBottom: "20px",
                    }}
                >
                    <Typography  sx={{ marginBottom: "10px",fontSize: "15px" , fontWeight: "bold" }}>
                        Estimated threat event frequency per year
                    </Typography>
                    <Weaknesses
                        data={aggregatedData} // Pass aggregated data to the chart
                        type="doughnut" 
                        datalabels={true}
                    />
                </Box>

                {/* Table Section */}
                <Box
                    sx={{
                        
                        borderRadius: 2,
                        bgcolor: "background.paper",
                        padding: "20px",
                         // Enable horizontal scrolling for small screens
                    }}
                >
                    <Typography
                        variant="h6"
                        sx={{
                            textAlign: "center",
                            marginBottom: "10px",
                            fontWeight: "bold",
                            fontSize: "15px",
                        }}
                    >
                        Detailed Threat Analysis 
                    </Typography>
                    <Paper>
                        <Table size="small" aria-label="threat details" sx={{ '& .MuiTableCell-root': { fontSize: '0.75rem' } }}>
                            <TableHead>
                            <TableRow>
                                <TableCell 
                                    align="start" 
                                    sx={{ 
                                    fontWeight: 'bold', 
                                    py: 0.5, 
                                    fontSize: '0.75rem',
                                    lineHeight: 1.2,
                                    maxWidth: '120px'  // Adjust width as needed
                                    }}
                                >
                                    Threat Scenario
                                </TableCell>
                                <TableCell 
                                    align="start" 
                                    sx={{ 
                                    fontWeight: 'bold', 
                                    py: 0.5,
                                    fontSize: '0.75rem',
                                    lineHeight: 1.2,
                                    // maxWidth: '100px',
                                    width: '80px'  // Adjust width as needed
                                    }}
                                >
                                    Min Events per year
                                </TableCell>
                                <TableCell 
                                    align="start" 
                                    sx={{ 
                                    fontWeight: 'bold', 
                                    py: 0.5,
                                    fontSize: '0.75rem',
                                    lineHeight: 1.2,
                                    width: '80px'  // Adjust width as needed
                                    }}
                                >
                                    Max Events per Year
                                </TableCell>
                                <TableCell 
                                    align="left" 
                                    sx={{ 
                                    fontWeight: 'bold', 
                                    py: 0.5,
                                    fontSize: '0.75rem',
                                    lineHeight: 1.2
                                    }}
                                >
                                    Description
                                </TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                            {tefData.map((tef, index) => (
                                <TableRow key={index}>
                                <TableCell align="center" sx={{ py: 0.5 }}>{t(tef["threat"])}</TableCell>
                                <TableCell align="center" sx={{ py: 0.5 }}>{tef["min"]}</TableCell>
                                <TableCell align="center" sx={{ py: 0.5 }}>{tef["max"]}</TableCell>
                                <TableCell align="left" sx={{ py: 0.5 }}>
                                    {tef["justification"]}
                                    <Divider sx={{ marginTop: "4px", borderBottomWidth: "1px", borderColor: "#ccc" }} />
                                </TableCell>
                                </TableRow>
                            ))}
                            </TableBody>
                        </Table>
                    </Paper>
                </Box>
            </Box>
        </Box>
    );
}